import React from 'react';
import PropTypes from 'prop-types';
import { Button, Stack, Typography } from '@mui/material';

const BLOCK_SX = {
    textAlign: 'center',
    py: { xs: 6, md: 10 },
};

const DESCRIPTION_SX = {
    color: 'text.secondary',
};

function NetworkErrorState({
    title, retryLabel, onRetry, testId, retryTestId, description = null,
}) {
    return (
        <Stack
            spacing={2}
            alignItems="center"
            sx={BLOCK_SX}
            data-testid={testId}
        >
            <Typography variant="headlineM" component="h1">{title}</Typography>
            {description ? (
                <Typography variant="bodyM" sx={DESCRIPTION_SX}>
                    {description}
                </Typography>
            ) : null}
            <Button
                variant="contained"
                onClick={onRetry}
                data-testid={retryTestId}
            >
                {retryLabel}
            </Button>
        </Stack>
    );
}

NetworkErrorState.propTypes = {
    title: PropTypes.string.isRequired,
    retryLabel: PropTypes.string.isRequired,
    onRetry: PropTypes.func.isRequired,
    testId: PropTypes.string.isRequired,
    retryTestId: PropTypes.string.isRequired,
    description: PropTypes.string,
};

export default NetworkErrorState;
